import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	breadcrumb: {
		id: 'spa-apps.project-settings.jira-automation.breadcrumb',
		defaultMessage: 'Automation',
		description: 'breadcrumbs for Jira automation page',
	},
});
